module.exports = __webpack_public_path__ + "static/img/img_c.338a3547.png";